import { BodyText, Card, Flex, Heading } from "@utilitywarehouse/hearth-react";
import parse from "html-react-parser";

import { QuestionsDataTest } from "../Questions/constants";

const WhyWeWant: React.FC<{ whyWeWantTexts: string[] }> = ({
  whyWeWantTexts,
}) => (
  <Card
    variant="subtle"
    colorScheme="neutralSubtle"
  >
    <Flex spacing="md" direction="column">
      <Heading size="md" data-testid={QuestionsDataTest.WHY_WE_WANT_LINK}>Why do we want to know this?</Heading>

      {whyWeWantTexts.map((text, index) => (
          <BodyText
            key={index}
            data-testid={QuestionsDataTest.WHY_WE_WANT}
          >
            {parse(text)}
          </BodyText>
        ))}
      </Flex>
  </Card>
);

export default WhyWeWant;
